module.exports = __webpack_public_path__ + "static/jonatan-8ea128af357760f3716b2c681a7d9983.png";